var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-form", { attrs: { "label-position": "top" } }, [
    _c("div", { staticClass: "contactum_card" }, [
      _c("div", { staticClass: "contactum_card_head" }, [
        _c("h2", { staticClass: "title" }, [
          _vm._v(" Cloudflare Turnstile Settings ")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text" }, [
          _vm._v(
            " CONTACTUM integrates with Cloudflare Turnstile, a free service that protects your website from spam and abuse. Please note, these settings are required only if you decide to use the Turnstile field. Read more about Cloudflare Turnstile.\n        Please generate API key and API secret using Cloudflare Turnstile\n      "
          ),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.cloudflare.com/en-gb/products/turnstile/",
                target: "_blank"
              }
            },
            [_vm._v("Read more about Cloudflare Turnstile.")]
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text" }, [
          _c("b", [
            _vm._v(
              "Please generate API key and API secret using Cloudflare Turnstile"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contactum_card_bdy" },
        [
          _c(
            "el-form-item",
            { staticClass: "contactum-form-item" },
            [
              _c(
                "template",
                { slot: "label" },
                [
                  _vm._v("Site Key\n          "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        placement: "bottom-start",
                        "popper-class": "contactum_tooltip_wrap"
                      }
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("p", [
                            _vm._v(
                              "Enter your Turnstile Site Key, if you do not have a key you can register for one at the provided link Turnstile is a free service.\n              "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "ff-icon ff-icon-info-filled text-primary"
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-input", {
                on: { change: _vm.load },
                model: {
                  value: _vm.turnstile.siteKey,
                  callback: function($$v) {
                    _vm.$set(_vm.turnstile, "siteKey", $$v)
                  },
                  expression: "turnstile.siteKey"
                }
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "contactum-form-item" },
            [
              _c(
                "template",
                { slot: "label" },
                [
                  _vm._v("Secret Key\n          "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        placement: "bottom-start",
                        "popper-class": "contactum_tooltip_wrap"
                      }
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("p", [
                            _vm._v(
                              "Enter your Turnstile Secret Key, if you do not have a key you can register for one at the provided link, Turnstile is a free service."
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "ff-icon ff-icon-info-filled text-primary"
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-input", {
                attrs: { type: "password" },
                on: { change: _vm.load },
                model: {
                  value: _vm.turnstile.secretKey,
                  callback: function($$v) {
                    _vm.$set(_vm.turnstile, "secretKey", $$v)
                  },
                  expression: "turnstile.secretKey"
                }
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "contactum-form-item" },
            [
              _c(
                "template",
                { slot: "label" },
                [
                  _vm._v("Appearance Mode\n          "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        placement: "bottom-start",
                        "popper-class": "contactum_tooltip_wrap"
                      }
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("p", [
                            _vm._v(
                              "You can select how the turnstile will appear\n              "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "ff-icon ff-icon-info-filled text-primary"
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-radio",
                {
                  staticClass: "mr-3",
                  attrs: { label: "always" },
                  model: {
                    value: _vm.turnstile.appearance,
                    callback: function($$v) {
                      _vm.$set(_vm.turnstile, "appearance", $$v)
                    },
                    expression: "turnstile.appearance"
                  }
                },
                [_vm._v("Managed")]
              ),
              _vm._v(" "),
              _c(
                "el-radio",
                {
                  staticClass: "mr-3",
                  attrs: { label: "execute" },
                  model: {
                    value: _vm.turnstile.appearance,
                    callback: function($$v) {
                      _vm.$set(_vm.turnstile, "appearance", $$v)
                    },
                    expression: "turnstile.appearance"
                  }
                },
                [_vm._v("Non-interactive")]
              ),
              _vm._v(" "),
              _c(
                "el-radio",
                {
                  staticClass: "mr-3",
                  attrs: { label: "interaction-only" },
                  model: {
                    value: _vm.turnstile.appearance,
                    callback: function($$v) {
                      _vm.$set(_vm.turnstile, "appearance", $$v)
                    },
                    expression: "turnstile.appearance"
                  }
                },
                [_vm._v("Invisible")]
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "contactum-form-item" },
            [
              _c(
                "template",
                { slot: "label" },
                [
                  _vm._v("Theme\n          "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        placement: "bottom-start",
                        "popper-class": "contactum_tooltip_wrap"
                      }
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [_c("p", [_vm._v("Choose a theme for the field")])]
                      ),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "ff-icon ff-icon-info-filled text-primary"
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-radio",
                {
                  attrs: { label: "auto" },
                  model: {
                    value: _vm.turnstile.theme,
                    callback: function($$v) {
                      _vm.$set(_vm.turnstile, "theme", $$v)
                    },
                    expression: "turnstile.theme"
                  }
                },
                [_vm._v("Auto")]
              ),
              _vm._v(" "),
              _c(
                "el-radio",
                {
                  attrs: { label: "light" },
                  model: {
                    value: _vm.turnstile.theme,
                    callback: function($$v) {
                      _vm.$set(_vm.turnstile, "theme", $$v)
                    },
                    expression: "turnstile.theme"
                  }
                },
                [_vm._v("Light")]
              ),
              _vm._v(" "),
              _c(
                "el-radio",
                {
                  attrs: { label: "dark" },
                  model: {
                    value: _vm.turnstile.theme,
                    callback: function($$v) {
                      _vm.$set(_vm.turnstile, "theme", $$v)
                    },
                    expression: "turnstile.theme"
                  }
                },
                [_vm._v("Dark")]
              )
            ],
            2
          ),
          _vm._v(" "),
          _vm.siteKeyChanged
            ? _c("el-form-item", { attrs: { label: "Validate Keys" } }, [
                _c("div", {
                  staticClass: "cf-turnstile",
                  attrs: {
                    id: "turnstile",
                    "data-sitekey": _vm.turnstile.siteKey
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.turnstile_status && !_vm.disabled
            ? _c("div", { attrs: { size: "sm", type: "success-soft" } }, [
                _c("p", [_vm._v(" Your Cloudflare Turnstile is valid ")])
              ])
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mt-4" },
      [
        _vm._v(
          "\n    " + _vm._s(_vm.disabled) + " " + _vm._s(_vm.loading) + "\n    "
        ),
        _c(
          "el-button",
          {
            attrs: {
              type: "primary",
              icon: "el-icon-success",
              disabled: _vm.disabled || _vm.loading,
              loading: false
            },
            on: { click: _vm.save }
          },
          [_vm._v("Save Settings\n    ")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            attrs: {
              type: "danger",
              icon: "ff-icon ff-icon-trash",
              loading: false
            },
            on: { click: _vm.clearSettings }
          },
          [_vm._v("Clear Settings")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }